const TIDAL_TELEMETRY = "TIDAL_TELEMETRY";
const coverageRootId = "tidal-coverage-root";
const dsName = "tidal";
const modalZIndex = "1300";
const componentIdentityMap = {
  muiDataDisplay: 3,
  muiFeedback: 4,
  muiInput: 2,
  muiLayout: 7,
  muiNavigation: 6,
  muiSurface: 5,
  muiUnknown: 1,
  muiUtil: 8,
  nonDs: 0,
  tidalDataDisplay: 13,
  tidalFeedback: 14,
  tidalInput: 12,
  tidalLayout: 17,
  tidalNavigation: 16,
  tidalSurface: 15,
  tidalUnknown: 11,
  tidalUtil: 18
};
export {
  TIDAL_TELEMETRY,
  componentIdentityMap,
  coverageRootId,
  dsName,
  modalZIndex
};
//# sourceMappingURL=constants.js.map
